var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAggiungiAppuntamento(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_9",
    "data-name": "Rettangolo 9",
    width: 32,
    height: 32,
    transform: "translate(1172.272 470.321)",
    fill: "#fff",
    stroke: "#b20d01",
    strokeLinecap: "round",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8510",
    "data-name": "Raggruppa 8510",
    transform: "translate(797 12545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8497",
    "data-name": "Raggruppa 8497",
    transform: "translate(133 300)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_4662",
    "data-name": "Rettangolo 4662",
    width: 50,
    height: 50,
    rx: 14,
    transform: "translate(-930 -12845)",
    fill: "#b20d01"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8498",
    "data-name": "Raggruppa 8498",
    transform: "translate(-19.029 49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8494",
    "data-name": "Raggruppa 8494",
    transform: "translate(1.029 40.619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prenota_appuntamento",
    transform: "translate(-1942.272 -13095.94)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar_1_",
    "data-name": "calendar (1)",
    transform: "translate(1174.15 472.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_15",
    "data-name": "Raggruppa 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_14",
    "data-name": "Raggruppa 14"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_3",
    "data-name": "Ellisse 3",
    cx: 1.106,
    cy: 1.106,
    r: 1.106,
    transform: "translate(20.234 10.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5",
    "data-name": "Tracciato 5",
    d: "M23.883,2.211H22.445V1.106a1.106,1.106,0,1,0-2.211,0V2.211H15.2V1.106a1.106,1.106,0,1,0-2.211,0V2.211H8.014V1.106a1.106,1.106,0,1,0-2.211,0V2.211H4.423A4.428,4.428,0,0,0,0,6.634V23.883a4.428,4.428,0,0,0,4.423,4.422h8.458a1.106,1.106,0,1,0,0-2.211H4.423a2.214,2.214,0,0,1-2.211-2.211V6.634A2.214,2.214,0,0,1,4.423,4.423H5.805V5.529a1.106,1.106,0,1,0,2.211,0V4.423h4.978V5.529a1.106,1.106,0,1,0,2.211,0V4.423h5.029V5.529a1.106,1.106,0,1,0,2.211,0V4.423h1.437a2.214,2.214,0,0,1,2.211,2.211v6.3a1.106,1.106,0,1,0,2.211,0v-6.3a4.428,4.428,0,0,0-4.422-4.423Z",
    fill: "#fff",
    stroke: "#b20d01",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_4",
    "data-name": "Ellisse 4",
    cx: 1.106,
    cy: 1.106,
    r: 1.106,
    transform: "translate(15.424 10.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_5",
    "data-name": "Ellisse 5",
    cx: 1.106,
    cy: 1.106,
    r: 1.106,
    transform: "translate(10.614 15.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_6",
    "data-name": "Ellisse 6",
    cx: 1.106,
    cy: 1.106,
    r: 1.106,
    transform: "translate(5.805 10.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_7",
    "data-name": "Ellisse 7",
    cx: 1.106,
    cy: 1.106,
    r: 1.106,
    transform: "translate(5.805 15.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_8",
    "data-name": "Ellisse 8",
    cx: 1.106,
    cy: 1.106,
    r: 1.106,
    transform: "translate(5.805 20.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_9",
    "data-name": "Ellisse 9",
    cx: 1.106,
    cy: 1.106,
    r: 1.106,
    transform: "translate(10.614 20.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_10",
    "data-name": "Ellisse 10",
    cx: 1.106,
    cy: 1.106,
    r: 1.106,
    transform: "translate(10.614 10.504)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8496",
    "data-name": "Raggruppa 8496",
    transform: "translate(4 -11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_779",
    "data-name": "Ellisse 779",
    transform: "translate(-756 -12557)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8495",
    "data-name": "Raggruppa 8495",
    transform: "translate(-752.003 -12553.004)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linea_1024",
    "data-name": "Linea 1024",
    y2: 7,
    transform: "translate(2.938 -0.496)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_1025",
    "data-name": "Linea 1025",
    y2: 6.579,
    transform: "translate(6.293 3.004) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAggiungiAppuntamento);
export default __webpack_public_path__ + "static/media/aggiungi_appuntamento.b71df6c84feba8fe8e9a8e4471188724.svg";
export { ForwardRef as ReactComponent };